import { render, staticRenderFns } from "./_revert.vue?vue&type=template&id=6a6f067a"
import script from "./_revert.vue?vue&type=script&lang=js"
export * from "./_revert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports